<!-- @format -->

<template>
	<div class="calc-pdf-cover-page">
		<header class="calc-pdf-cover-page__header">
			<div class="calc-pdf-cover-page__brand">
				<LinxfourLogo />
				<div class="calc-pdf-cover-page__tagline">
					{{ $t('calculation_pdf.mini-calculator_page_1-tagline') }}
				</div>
			</div>

			<div class="calc-pdf-cover-page__partners">
				<div class="calc-pdf-cover-page__partners-heading">
					{{ $t('calculation_pdf.mini-calculator_page_1-partners_heading') }}
				</div>
				<img
					v-for="partner in partnerLogos"
					:key="partner.name"
					:src="partner.src"
					:alt="partner.name"
					:class="[
						'calc-pdf-cover-page__partner-logo',
						{ 'calc-pdf-cover-page__partner-logo--small': partner.small },
					]"
				/>
			</div>
		</header>

		<section class="calc-pdf-cover-page__title-block">
			<h1 class="calc-pdf-cover-page__title">
				{{ $t('calculation_pdf.mini-calculator_page_1-heading') }}
			</h1>
			<hr class="calc-pdf-cover-page__title-divider" />
			<p class="calc-pdf-cover-page__subtitle">
				{{ $t('calculation_pdf.mini-calculator_page_1-sub_heading') }}
			</p>
		</section>

		<hr class="calc-pdf-cover-page__divider" />

		<section class="calc-pdf-cover-page__footer">
			<div class="calc-pdf-cover-page__footer-col">
				<h2 class="calc-pdf-cover-page__footer-heading">
					{{ $t('calculation_pdf.mini-calculator_page_1-footer_heading_left') }}
				</h2>
				<div class="calc-pdf-cover-page__contact-row">
					<div>
						<div class="calc-pdf-cover-page__contact-label">
							{{ $t('calculation_pdf.mini-calculator_page_1-contact_label') }}
						</div>
						<div>{{ $t('calculation_pdf.page_5-contact_name') }}</div>
						<div>sales@linxfour.com</div>
						<div>{{ $t('calculation_pdf.page_5-contact_mobile') }}</div>
					</div>
					<div>
						<div class="calc-pdf-cover-page__contact-label">
							{{ $t('calculation_pdf.mini-calculator_page_1-company_label') }}
						</div>
						<div>{{ $t('§corporate_info.company1_name') }}</div>
						<div>{{ $t('§corporate_info.company1_address_line1') }}</div>
						<div>{{ $t('§corporate_info.company1_address_postalcode') }}, {{ $t('§corporate_info.company1_address_city') }} {{ $t('§corporate_info.company1_address_country') }}</div>
						<div>www.linxfour.com</div>
					</div>
				</div>
			</div>

			<div class="calc-pdf-cover-page__footer-col">
				<h2 class="calc-pdf-cover-page__footer-heading">
					{{ $t('calculation_pdf.mini-calculator_page_1-footer_heading_right') }}
				</h2>
				<div class="calc-pdf-cover-page__stats">
					<div class="calc-pdf-cover-page__stat">
						<div class="calc-pdf-cover-page__stat-label">
							{{ $t('calculation_pdf.mini-calculator_page_1-stat_1-label') }}
						</div>
						<div class="calc-pdf-cover-page__stat-value">
							{{ $t('calculation_pdf.mini-calculator_page_1-stat_1-value') }}
						</div>
					</div>
					<div class="calc-pdf-cover-page__stat">
						<div class="calc-pdf-cover-page__stat-label">
							{{ $t('calculation_pdf.mini-calculator_page_1-stat_2-label') }}
						</div>
						<div class="calc-pdf-cover-page__stat-value">
							{{ $t('calculation_pdf.mini-calculator_page_1-stat_2-value') }}
						</div>
					</div>
					<div class="calc-pdf-cover-page__stat">
						<div class="calc-pdf-cover-page__stat-label">
							{{ $t('calculation_pdf.mini-calculator_page_1-stat_3-label') }}
						</div>
						<div class="calc-pdf-cover-page__stat-value">
							{{ $t('calculation_pdf.mini-calculator_page_1-stat_3-value') }}
						</div>
					</div>
				</div>
			</div>
		</section>

		<div class="calc-pdf-cover-page__bottom-row">
			<p class="calc-pdf-cover-page__confidentiality">
				{{ $t('calculation_pdf.mini-calculator_page_1-confidentiality') }}
			</p>
			<p class="calc-pdf-cover-page__date">{{ formatDate(new Date(), locale) }}</p>
		</div>
	</div>
</template>

<script>
import LinxfourLogo from './LinxfourLogo.vue'
import { formatDate } from '../../helpers/format.js'

export default {
	name: 'CalcPdfCoverPage',

	components: {
		LinxfourLogo,
	},

	props: {
		locale: {
			type: String,
			default: 'en-GB',
		},
	},

	data() {
		return {
			partnerLogos: [
				{ name: 'MAKINO', src: '/calculator-assets/images/makino.png' },
				{ name: 'Tamturbo', src: '/calculator-assets/images/tamturbo.png' },
				{ name: 'KraussMaffei', src: '/calculator-assets/images/kraussMaffei.png', small: true },
				{ name: 'WashTec', src: '/calculator-assets/images/washtec.png' },
				{ name: 'BEUMERGROUP', src: '/calculator-assets/images/baumer.png' },
				{ name: 'kardex', src: '/calculator-assets/images/kardex.png', small: true },
				{ name: 'ENGEL', src: '/calculator-assets/images/engel.png' },
			],
		}
	},

	methods: {
		formatDate,
	},
}
</script>

<style scoped>
.calc-pdf-cover-page {
	--color-primary-500: #55e38e;
	--color-secondary-900: #040f0f;
	--color-neutral-100: #ffffff;
	--text-dark-muted: #62817f;
	--font-family-sans: 'TWK Lausanne', sans-serif;

	position: relative;
	box-sizing: border-box;
	width: 1750px;
	height: 1000px;
	padding: 56px 80px 40px;
	background-color: var(--color-primary-500);
	background-image: url('/calculator-assets/fe_background.png');
	background-size: cover;
	background-position: center;
	color: var(--color-secondary-900);
	font-family: var(--font-family-sans);
	display: flex;
	flex-direction: column;
}

.calc-pdf-cover-page__header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

.calc-pdf-cover-page__brand :deep(svg) {
	width: 240px;
	height: auto;
}

.calc-pdf-cover-page__tagline {
	margin-top: 6px;
	font-size: 18px;
	font-weight: 500;
}

.calc-pdf-cover-page__partners {
	position: absolute;
	top: 200px;
	right: 80px;
	text-align: right;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 16px;
}

.calc-pdf-cover-page__partners-heading {
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 4px;
}

.calc-pdf-cover-page__partner-logo {
	height: 45px;
	width: auto;
	object-fit: contain;
}

.calc-pdf-cover-page__partner-logo--small {
	height: 35px;
}

.calc-pdf-cover-page__title-block {
	margin-top: 200px;
	max-width: 1500px;
}

.calc-pdf-cover-page__title {
	font-size: 98px;
	font-weight: 700;
	line-height: 1.05;
	margin: 0;
}

.calc-pdf-cover-page__title-divider {
	border: none;
	border-top: 3px solid var(--color-secondary-900);
	width: 575px;
	margin: 18px 0;
}

.calc-pdf-cover-page__subtitle {
	font-size: 52px;
	font-weight: 500;
	margin: 0;
}

.calc-pdf-cover-page__divider {
	margin-top: auto;
	margin-bottom: 20px;
	border: none;
	border-top: 1.5px solid var(--color-secondary-900);
}

.calc-pdf-cover-page__footer {
	display: flex;
	gap: 48px;
}

.calc-pdf-cover-page__footer-col {
	flex: 1;
}

.calc-pdf-cover-page__footer-heading {
	font-size: 28px;
	font-weight: 500;
	margin: 0 0 16px;
}

.calc-pdf-cover-page__contact-row {
	display: flex;
	gap: 40px;
	font-size: 18px;
	line-height: 1.45;
}

.calc-pdf-cover-page__contact-label {
	font-weight: 700;
	margin-bottom: 6px;
}

.calc-pdf-cover-page__stats {
	display: flex;
	gap: 40px;
}

.calc-pdf-cover-page__stat-label {
	font-size: 18px;
	font-weight: 700;
	margin-bottom: 6px;
}

.calc-pdf-cover-page__stat-value {
	font-size: 20px;
	font-weight: 300;
}

.calc-pdf-cover-page__bottom-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 16px;
	gap: 32px;
}

.calc-pdf-cover-page__confidentiality {
	font-size: 15px;
	line-height: 1.4;
	max-width: 1350px;
	margin: 0;
}

.calc-pdf-cover-page__date {
	font-size: 18px;
	white-space: nowrap;
	margin: 0;
}
</style>
